import axios, { AxiosResponse } from 'axios'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export interface LoyaltyActivityItemType {
  id: string | number
  name: string
  start_date: string
  start_time: string
  end_date: string
  end_time: string
  coin_earn: number
  multiplier: number
  is_active: boolean
  is_all_day: boolean
}

export interface LoyaltyActivityParamsType {
  name: string
  sort: string
  direction: string
  pageSize: number
  pageIndex: number
}

export interface LoyaltyActivityMutationPayloadType {
  name?: string
  start_date?: string | number
  start_time?: string | number
  end_date?: string | number
  end_time?: string | number
  coin_earn?: string | number
  multiplier?: string | number
  is_active?: boolean
  is_all_day?: boolean
  [key: string]: unknown
}

export interface LoyaltyActivityPaginationType {
  pageSize: number
  pageIndex: number
  totalPages: number
  totalElement: number
  numberOfElements: number
}

export const getLoyaltyActivity = (
  params: LoyaltyActivityParamsType,
): Promise<
  AxiosResponse<{ data: LoyaltyActivityItemType[]; pagination: LoyaltyActivityPaginationType }>
> => axios.get(`${baseUrl}/api/loyalty/activity-rules`, { params })

export const getLoyaltyActivityDetail = (
  id: string | number,
): Promise<AxiosResponse<{ data: LoyaltyActivityItemType }>> =>
  axios.get(`${baseUrl}/api/loyalty/activity-rules/${id}`)

export const postLoyaltyActivity = (
  payload: LoyaltyActivityMutationPayloadType,
): Promise<AxiosResponse> => axios.post(`${baseUrl}/api/loyalty/activity-rules`, payload)

export const putLoyaltyActivity = (
  id: string | number,
  payload: LoyaltyActivityMutationPayloadType,
): Promise<AxiosResponse> => axios.put(`${baseUrl}/api/loyalty/activity-rules/${id}`, payload)

export const putLoyaltyActivityType = (
  type: string | number,
  payload: LoyaltyActivityMutationPayloadType,
): Promise<AxiosResponse> => axios.put(`${baseUrl}/api/loyalty/activity-rules/${type}`, payload)

export const deleteLoyaltyActivity = (id: string | number): Promise<AxiosResponse> =>
  axios.delete(`${baseUrl}/api/loyalty/activity-rules/${id}`)
